<template>
    <div>
        <input type="hidden" name="browser_name" :value="browserName">
        <input type="hidden" name="browser_versioin" :value="browserVersion">
        <input type="hidden" name="os_name" :value="osName">
        <input type="hidden" name="os_version" :value="osVersion">
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import Bowser from "bowser";

const browser = ref('');
const os = ref('');

/**
 * Get the users browser version
 */
const detectUserBrowserAndOs = () => {
    const browserParser = Bowser.getParser(window.navigator.userAgent);

    // get browser details
    browser.value = browserParser.getBrowser();

    // get os details
    os.value = browserParser.getOS();
};

const browserName = computed(() => {
    if (browser.value === '' || browser.value.name === undefined) return '';
    return browser.value.name;
});

const browserVersion = computed(() => {
    if (browser.value === '' || browser.value.version === undefined) return '';
    return browser.value.version;
});

const osName = computed(() => {
    if (os.value === '' || os.value.name === undefined) return '';
    return os.value.name;
});

const osVersion = computed(() => {
    if (os.value === '' || os.value.version === undefined) return '';
    return os.value.version;
});

onMounted(() => {
    detectUserBrowserAndOs();
});
</script>